import { Injectable, computed, inject } from '@angular/core';
import { IAccountFormat, IDebitsModel } from '@partners/api';
import { DebitsStore } from '@partners/state';

@Injectable({
  providedIn: 'root'
})
export class DebitsFacade {
  /** a signal holding bank account details (used to display on account-label component) */
  accountFormat$$ = computed<IAccountFormat>(() => {
    const debitsModel: IDebitsModel = this._debitsStore.model$$();

    if (!debitsModel) {
      return undefined;
    }
    const { accountNumber, bankName, branchName, accountOwnerName, branchCode } = debitsModel;

    return {
      accountNumber: accountNumber,
      bankName: bankName,
      branchName: branchName,
      accountOwnerName: accountOwnerName,
      branchCode: branchCode
    };
  });

  private _debitsStore = inject(DebitsStore);

  constructor() {}
}
